import React, { Component } from 'react';
import './Pages.css';


class NotPermissions extends Component {

  render() {
    return (
      <header id="headerxw" className="page-not-found">
        <div className="navbar navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <a className="navbar-brand animated zoomInUp" href="#intro"><img src="assets/img/logo.png" alt="logo"/></a>
            </div>
          </div>
        </div>
        <div className="container message animated bounceInUp">
         <div className="row">
           <div className="text-center">
               <h1>Hola! si quieres pedir la promoción debes decirle a tu amigo que te taguee en el post en el que la encontró e ingresar haciendo click desde tu celular</h1>
               <p>Si crees que es un error escribenos a <a className="mail" href="mailto:bugs@rappi.com?Subject=Reporte%20de%20bug">bugs@rappi.com</a></p>
               <div className="action platforms">
                     <a  className="download" href="https://play.google.com/store/apps/details?id=com.grability.rappi&hl=es_419"><img src="assets/img/googleplay.png" alt=""/>Google Play</a>

                     <a className="download" href="https://itunes.apple.com/us/app/rappi-todo-lo-que-quieras-a-domicilio/id984044296?mt=8"><img src="assets/img/appstore.png" alt=""/>App Store</a>
                       <a className="download hidden-xs"  href="http://rappi.com/">www.rappi.com</a>
              </div>

              <div className="action platforms hidden-lg hidden-md">
                      <a className="download"  href="http://rappi.com/">www.rappi.com</a>
             </div>

           </div>
         </div>
        </div>
      </header>

    );
  }
}


export default NotPermissions;



// WEBPACK FOOTER //
// ./src/components/pages/NotPermissions.js